export enum IPSelectableOptionMenuItemType {
  Normal = 0,
  Divider = 1,
  Header = 2,
  SelectAll = 3,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IPSelectableOptionGroup<T = any> {
  groupLabel?: string;
  options: IPSelectableOption<T>[];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IPSelectableOption<T = any> {
  /**
   * Arbitrary string associated with this option.
   */
  key: string | number;
  /**
   * ID attribute associated with this option
   */
  id?: string;
  /**
   * Text to render for this option
   */
  text: string;
  /**
   * Title attribute (built in tooltip) for a given option.
   */
  title?: string;
  /**
   * Text to render for this option
   * Note: the SelectAll itemType is only supported on one option in multiselect components
   */
  itemType?: IPSelectableOptionMenuItemType;
  /**
   * Index for this option
   */
  index?: number;
  /**
  /** If option is selected. */
  selected?: boolean;
  /**
   * Whether the option is disabled
   * @defaultvalue false
   */
  disabled?: boolean;
  /**
   * Data available to custom onRender functions.
   */
  data?: T;
}
